// ═══════════════════════════════════════════════════════════════════
//  modules/courriel/MailHtml.js
//  MailHtml
// ═══════════════════════════════════════════════════════════════════

import { useEffect, useRef } from "react";

// Le HTML est déjà assaini côté serveur (DOMPurify). Ici on ne fait que
// réactiver les images si l'utilisateur le demande explicitement.
export function MailHtml({ html, imagesVisibles }) {
  const ref = useRef(null);
  useEffect(() => {
    if (!ref.current) return;
    ref.current.innerHTML = html;
    if (imagesVisibles) {
      ref.current.querySelectorAll("img[data-blocked-src]").forEach((img) => {
        img.setAttribute("src", img.getAttribute("data-blocked-src"));
      });
    }
    ref.current.querySelectorAll("img").forEach((img) => { img.style.maxWidth = "100%"; img.style.height = "auto"; });
  }, [html, imagesVisibles]);
  return <div ref={ref} />;
}
